import Vue from 'vue'
import Router from 'vue-router'
import routerList from './router'
import {
  getToken
} from '@/libs/cookieUtil'
import {
  oauthLogin
} from '@/libs/api'
import {
  Message,
  MessageBox
} from 'element-ui'
import store from '../store'

Vue.use(Router)

const router = new Router({
  routes: routerList
})

//前置路由
router.beforeEach((to, from, next) => {
  var withoutToken = ['login', 'register', 'forget', 'scan']
  //如果已经登录过了
  if (getToken()) {
    if (withoutToken.indexOf(to.name) > -1) { //如果是不需要token的页面
      next('/home/activitySelect')
    } else {
      next();
    }
  } else { //如果没有登录过
    if (withoutToken.indexOf(to.name) > -1) { //如果是不需要token的页面
      next();
    } else {
      if (to.query.code != undefined && to.query.state != undefined) {
        oauthLogin(to.query.code, to.query.state).then(res => {
          if (res.status) {
            var userInfo = Object.assign(res.content.userInfo, {
              name: res.content.userInfo.fullName
            })
            store.commit("updateToken", res.content.token)
            sessionStorage.setItem('updateToken', res.content.token)
            store.commit("updateAccountInfo", res.content.userInfoDTO)
            sessionStorage.setItem('userInfo', JSON.stringify(res.content.userInfoDTO))
            next('/home/activitySelect')
          } else {
            //store.commit("updateToken", '123123123213')
            MessageBox("登录失败," + res.message, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `action: ${action}`
                });
              }
            });
            next('login')
            //next('home')
          }
        })
      } else {
        next('login')
      }
    }
  }
})

//后置路由
router.afterEach((to, from, next) => {

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js